/* PATO Golf storefront helpers (on top of Horizon). */

/*
 * Prices in the shopper's currency. The store charges in GBP (PayPal converts
 * at payment), so prices are shown as approximate EUR for the eurozone, exact
 * GBP for the UK, and approximate USD for everyone else.
 */
( function () {
	var cfg = window.PATO || {};
	var EURO = [ 'AT', 'BE', 'BG', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK', 'AD', 'MC', 'SM', 'VA', 'ME', 'XK', 'GF', 'GP', 'MQ', 'RE', 'YT', 'PM', 'BL', 'MF', 'AX' ];
	var GBP = [ 'GB', 'IM', 'JE', 'GG' ];
	var base = cfg.shopCurrency || 'GBP';

	function target() {
		var c = ( cfg.country || '' ).toUpperCase();
		if ( GBP.indexOf( c ) > -1 ) {
			return 'GBP';
		}
		if ( EURO.indexOf( c ) > -1 ) {
			return 'EUR';
		}
		return 'USD';
	}
	var to = target();
	if ( to === base ) {
		return;
	}
	var fmt = new Intl.NumberFormat( 'en', { style: 'currency', currency: to, maximumFractionDigits: 0 } );

	// Horizon prints prices in several places (cards, product page, cart), always
	// inside <bdi>, so convert any GBP amount found there.
	var SYMBOL = /£\s?([\d,]+(?:\.\d+)?)(?:\s?GBP)?/g;

	function convert( root ) {
		if ( ! window.Currency || ! window.Currency.rates || ! window.Currency.rates[ base ] || ! window.Currency.rates[ to ] ) {
			return;
		}
		var rate = window.Currency.rates[ base ] / window.Currency.rates[ to ];
		( root || document ).querySelectorAll( 'bdi, [data-pato-cents]' ).forEach( function ( el ) {
			var text = el.textContent.trim();
			if ( text === el.getAttribute( 'data-pato-out' ) || text.indexOf( '£' ) === -1 || el.closest( '#pato-welcome' ) ) {
				return;
			}
			var out = '≈ ' + text.replace( SYMBOL, function ( m, amount ) {
				return fmt.format( parseFloat( amount.replace( /,/g, '' ) ) * rate );
			} );
			el.classList.add( 'is-converted' );
			el.setAttribute( 'title', text.replace( /\s?GBP$/, '' ) + ' (' + base + ') at checkout' );
			el.setAttribute( 'data-pato-out', out );
			el.textContent = out;
		} );
		notes();
	}

	function notes() {
		var money = fmt.resolvedOptions().currency;
		// Product page: say what will actually be charged.
		if ( cfg.template === 'product' ) {
			var first = document.querySelector( 'main .product-details product-price bdi.is-converted' );
			if ( first && ! document.querySelector( '.pato-charged-note' ) ) {
				var n = document.createElement( 'span' );
				n.className = 'pato-charged-note';
				n.textContent = 'You’ll be charged ' + first.getAttribute( 'title' ).replace( ' at checkout', '' ) + ' at checkout.';
				( first.closest( 'product-price, .price, [class*="price"]' ) || first.parentNode ).appendChild( n );
			}
		}
		// Cart drawer and cart page.
		document.querySelectorAll( '.cart-totals__tax-note' ).forEach( function ( tax ) {
			if ( ! tax.parentNode.querySelector( '.pato-cart-note' ) ) {
				var p = document.createElement( 'p' );
				p.className = 'pato-cart-note';
				p.textContent = 'Prices in ' + money + ' are approximate. You’ll pay in ' + base + ' at checkout, and PayPal converts it for you.';
				tax.after( p );
			}
		} );
	}

	function start() {
		convert( document );
		new MutationObserver( function () {
			convert( document );
		} ).observe( document.body, { childList: true, subtree: true } );
	}
	if ( window.Currency ) {
		start();
	} else {
		window.addEventListener( 'load', start );
	}
} )();

/* Golf cart drives off when something is added. */
( function () {
	var last = null;
	function check() {
		var bubble = document.querySelector( '.header-actions__cart-icon .cart-bubble__text, .cart-bubble__text' );
		var count = bubble ? bubble.textContent.trim() : '';
		if ( last !== null && count !== last && count !== '' && count !== '0' ) {
			document.querySelectorAll( '.action__cart' ).forEach( function ( el ) {
				el.classList.remove( 'pato-drive' );
				void el.offsetWidth;
				el.classList.add( 'pato-drive' );
			} );
		}
		last = count;
	}
	document.addEventListener( 'DOMContentLoaded', function () {
		check();
		new MutationObserver( check ).observe( document.body, { childList: true, subtree: true, characterData: true } );
	} );
} )();

/* Welcome offer popup: shows once, after a short delay or some scrolling. */
( function () {
	function init() {
		var box = document.getElementById( 'pato-welcome' );
		if ( ! box ) {
			return;
		}
		function cookie( name ) {
			var m = document.cookie.match( new RegExp( '(?:^|; )' + name + '=([^;]*)' ) );
			return m ? decodeURIComponent( m[ 1 ] ) : '';
		}
		function remember( value, days ) {
			document.cookie = 'pato_welcome=' + value + '; path=/; max-age=' + days * 86400 + '; samesite=lax';
		}
		var success = box.querySelector( '[data-success]' );
		var hasError = box.querySelector( '.pato-welcome__msg.is-error' );
		var shown = false;
		var lastFocus = null;

		function open() {
			if ( shown ) {
				return;
			}
			shown = true;
			lastFocus = document.activeElement;
			box.hidden = false;
			var input = box.querySelector( 'input[type=email]' );
			if ( input ) {
				setTimeout( function () {
					input.focus();
				}, 50 );
			}
		}
		function close() {
			box.hidden = true;
			if ( ! success ) {
				remember( 'dismissed', 14 );
			}
			if ( lastFocus && lastFocus.focus ) {
				lastFocus.focus();
			}
		}
		box.querySelectorAll( '[data-close]' ).forEach( function ( el ) {
			el.addEventListener( 'click', close );
		} );
		document.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'Escape' && ! box.hidden ) {
				close();
			}
		} );
		var copy = box.querySelector( '.pato-welcome__copy' );
		if ( copy ) {
			copy.addEventListener( 'click', function () {
				if ( navigator.clipboard ) {
					navigator.clipboard.writeText( 'WELCOME5' ).then( function () {
						copy.textContent = 'Copied';
					}, function () {} );
				}
			} );
		}

		// Just subscribed (or the form came back with an error): show the result straight away.
		if ( success || hasError ) {
			if ( success ) {
				remember( 'subscribed', 365 );
				box.querySelector( '.pato-welcome__no' ).textContent = 'Start shopping';
			}
			open();
			return;
		}
		if ( cookie( 'pato_welcome' ) ) {
			return;
		}
		var timer = setTimeout( open, 6000 );
		window.addEventListener( 'scroll', function onScroll() {
			if ( window.scrollY > window.innerHeight * 0.6 ) {
				clearTimeout( timer );
				window.removeEventListener( 'scroll', onScroll );
				open();
			}
		}, { passive: true } );
	}
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();

/* Sale countdown. The bar is only rendered while a sale is on. */
( function () {
	function init() {
		var bar = document.getElementById( 'pato-sale' );
		if ( ! bar ) {
			return;
		}
		var ends = parseInt( bar.getAttribute( 'data-ends' ), 10 ) * 1000;
		var parts = {};
		[ 'd', 'h', 'm', 's' ].forEach( function ( k ) {
			parts[ k ] = bar.querySelector( '[data-' + k + ']' );
		} );
		function pad( n ) {
			return n < 10 ? '0' + n : String( n );
		}
		function tick() {
			var left = Math.floor( ( ends - Date.now() ) / 1000 );
			if ( left < 0 ) {
				bar.remove();
				return;
			}
			parts.d.textContent = pad( Math.floor( left / 86400 ) );
			parts.h.textContent = pad( Math.floor( left % 86400 / 3600 ) );
			parts.m.textContent = pad( Math.floor( left % 3600 / 60 ) );
			parts.s.textContent = pad( left % 60 );
			setTimeout( tick, 1000 - ( Date.now() % 1000 ) );
		}
		tick();
	}
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();

/*
 * During a sale (the countdown bar is on the page) show the price with the
 * automatic 15% off next to the regular one, on product pages and cards.
 * The discount itself is applied by Shopify at checkout.
 */
( function () {
	var OFF = 0.15;
	function saleText( text ) {
		var m = text.match( /^(≈\s*)?([^\d\s]*)\s?([\d,]+(?:\.\d+)?)(\s?[A-Z]{3})?$/ );
		if ( ! m ) {
			return '';
		}
		var value = parseFloat( m[ 3 ].replace( /,/g, '' ) ) * ( 1 - OFF );
		var decimals = m[ 3 ].indexOf( '.' ) > -1 ? 2 : 0;
		return ( m[ 1 ] || '' ) + m[ 2 ] + value.toFixed( decimals ).replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
	}
	function apply() {
		if ( ! document.getElementById( 'pato-sale' ) ) {
			return;
		}
		document.querySelectorAll( 'product-price .price > bdi, .pato-card__price > bdi' ).forEach( function ( el ) {
			var sale = saleText( el.textContent.trim() );
			if ( ! sale ) {
				return;
			}
			var tag = el.nextElementSibling && el.nextElementSibling.classList.contains( 'pato-sale-price' ) ? el.nextElementSibling : null;
			if ( ! tag ) {
				tag = document.createElement( 'span' );
				tag.className = 'pato-sale-price';
				el.after( tag );
				el.classList.add( 'pato-was' );
			}
			if ( tag.textContent !== sale ) {
				tag.textContent = sale;
			}
		} );
		// "You'll be charged £X (GBP)" should quote the discounted GBP amount.
		var note = document.querySelector( '.pato-charged-note' );
		var gbp = document.querySelector( 'main .product-details product-price bdi.is-converted' );
		if ( note && gbp && ! note.hasAttribute( 'data-sale' ) ) {
			var orig = ( gbp.getAttribute( 'title' ) || '' ).replace( ' (GBP) at checkout', '' );
			var discounted = saleText( orig );
			if ( discounted ) {
				note.setAttribute( 'data-sale', '' );
				note.textContent = 'With the 15% off, you’ll be charged ' + discounted + ' (GBP) at checkout.';
			}
		}
	}
	function start() {
		apply();
		new MutationObserver( apply ).observe( document.body, { childList: true, subtree: true, characterData: true } );
	}
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', start );
	} else {
		start();
	}
} )();

/* Hero rotator: one product at a time, pauses on hover, still for reduced motion. */
( function () {
	function init() {
		document.querySelectorAll( '.pato-rotator' ).forEach( function ( box ) {
			// keep the first product, shuffle the rest so every visit shows a mix
			var rest = Array.prototype.slice.call( box.querySelectorAll( '.pato-rotator__slide' ), 1 );
			for ( var k = rest.length - 1; k > 0; k-- ) {
				var j = Math.floor( Math.random() * ( k + 1 ) );
				var t = rest[ k ];
				rest[ k ] = rest[ j ];
				rest[ j ] = t;
			}
			var dotsBox = box.querySelector( '.pato-rotator__dots' );
			rest.forEach( function ( el ) {
				box.insertBefore( el, dotsBox );
			} );
			var slides = box.querySelectorAll( '.pato-rotator__slide' );
			var dots = box.querySelectorAll( '.pato-rotator__dots i' );
			if ( slides.length < 2 || window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
				return;
			}
			// load the rest of the images once the page is idle
			slides.forEach( function ( s ) {
				var img = s.querySelector( 'img' );
				if ( img ) {
					img.loading = 'eager';
				}
			} );
			var i = 0;
			var paused = false;
			box.addEventListener( 'mouseenter', function () {
				paused = true;
			} );
			box.addEventListener( 'mouseleave', function () {
				paused = false;
			} );
			setInterval( function () {
				if ( paused || document.hidden ) {
					return;
				}
				slides[ i ].classList.remove( 'is-active' );
				slides[ i ].setAttribute( 'aria-hidden', 'true' );
				slides[ i ].tabIndex = -1;
				if ( dots[ i ] ) {
					dots[ i ].classList.remove( 'is-active' );
				}
				i = ( i + 1 ) % slides.length;
				slides[ i ].classList.add( 'is-active' );
				slides[ i ].removeAttribute( 'aria-hidden' );
				slides[ i ].removeAttribute( 'tabindex' );
				if ( dots[ i ] ) {
					dots[ i ].classList.add( 'is-active' );
				}
			}, parseInt( box.getAttribute( 'data-interval' ), 10 ) || 3200 );
		} );
	}
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
